// 神策相关文件夹
import sensors from "sa-sdk-javascript";

// const ddType = () => {
//     if ((window as any).dd && (window as any).dd.android) {
//         return "Android"
//     } else if ((window as any).dd && (window as any).dd.ios) {
//         return "iOS"
//     } else {
//         return "web"
//     }
// }

export function init(workcode: string | number): void {
  if (!workcode) return;
  const workcodeStr = workcode + "";
  (window as any).sensorsData = sensors.init({
    // server_url: 'https://sensorsdata-2.talbrain.com:8080/sa?project=default', // 测试
    // server_url: 'https://sensorsdata-2.talbrain.com:8080/sa?project=yach', // 线上
    server_url: process.env.VUE_APP_SENSORS_URL,
    cross_subdomain: true,
    show_log: false,
    heatmap: {
      //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      //需要 JSSDK 版本号大于 1.7
      clickmap: "default",
      //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      //需要 JSSDK 版本号大于 1.9.1
      scroll_notice_map: "not_collect",
    },
    is_track_single_page: function(last_url) {
      return true; // 时候，使用默认发送的 $pageivew
      // return false 时候，不执行默认的 $pageview
      // return {} 时候，把对象中的属性，覆盖默认 $pageview 里的属性
    },
  });

  const obj = {
    version: process.env.VUE_APP_MUSE_VERSION,
    server_url: process.env.VUE_APP_SENSORS_URL,
  };

  sensors.quick("autoTrack", obj);
  sensors.registerPage(obj);
  sensors.login(workcodeStr);
  (window as any).sensorsData = sensors;
}

export function track(eventName: string, eventData: object): void {
  if (!eventData) eventData = {};
  if ((window as any).sensorsData)
    (window as any).sensorsData.track(eventName, eventData);
}
